export default "__VITE_ASSET__DfPzaf$L__"